var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.download
    ? _c("a", {
        staticClass: "mdi vs-icon-button",
        class: _vm.classes,
        attrs: {
          download: "download",
          href: _vm.download,
          title: _vm.title,
          target: _vm.target
        }
      })
    : _vm.href
    ? _c("a", {
        staticClass: "mdi vs-icon-button",
        class: _vm.classes,
        attrs: { href: _vm.href, title: _vm.title, target: _vm.target }
      })
    : _c("div", {
        staticClass: "mdi vs-icon-button",
        class: _vm.classes,
        attrs: { title: _vm.title, target: _vm.target },
        on: { click: _vm.handleClick }
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }